import React, { FC } from "react";
import { Box } from "@mui/material";
import { IGarageList, GarageDetailsAdditionalData } from "../../../interfaces/Interfaces";
import { TextInfoItem } from "../../table/TextInfoItem";
import { IdlocaGeneric } from "../../../locales/IdlocaGeneric";
import { RenderRating } from "../list/RenderRating";
import { FormatWorkingHours } from "../../../utils/FormatWorkingHours";
import LanguageIcon from "@mui/icons-material/Language";
import PlaceIcon from "@mui/icons-material/Place";

interface Props {
    garage: IGarageList;
    details: GarageDetailsAdditionalData | null;
}

export const GarageDetailsInfo: FC<Props> = ({ garage, details }) => (
    <Box sx={{ flex: 1, minWidth: 300, display: "flex", flexDirection: "column", gap: 1 }}>
        <TextInfoItem locaId={IdlocaGeneric.address} value={garage.address} />
        <TextInfoItem locaId={IdlocaGeneric.type} value={garage.type} />
        <TextInfoItem locaId={IdlocaGeneric.rating} renderer={<RenderRating value={garage.rating} />} />
        <TextInfoItem locaId={IdlocaGeneric.contact} value={details?.internationalPhoneNumber} />

        {details?.currentOpeningHours?.periods && (
            <TextInfoItem
                locaId={IdlocaGeneric.working_hours}
                renderer={<FormatWorkingHours data={details.currentOpeningHours.periods} />}
            />
        )}

        {details?.websiteUri && (
            <TextInfoItem
                locaId={IdlocaGeneric.website}
                renderer={
                    <ExternalLink href={details.websiteUri} icon={<LanguageIcon fontSize="small" />} />
                }
            />
        )}

        {details?.googleMapsUri && (
            <TextInfoItem
                locaId={IdlocaGeneric.google_maps}
                renderer={
                    <ExternalLink href={details.googleMapsUri} icon={<PlaceIcon fontSize="small" />} />
                }
            />
        )}
    </Box>
);

const ExternalLink: FC<{ href: string; icon: React.ReactNode }> = ({ href, icon }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon}
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#1976d2", fontWeight: 500 }}
        >
            {href}
        </a>
    </Box>
);
